export default __webpack_public_path__ + "static/media/quizposter1.57bc71ef.jpg";